<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<!--
Dungeons and dragons rules: http://dnd.wizards.com/articles/features/basicrules
Videos de cómo ser un mejor dungeon master: https://www.youtube.com/watch?v=yQHQI6xADw4&index=2&list=PLsHhMRkG9uA65q8hN8NJdNeRG-CCkKdnM
-->

<script>
  export default {
    data () {
      return {
        
      }
    }
  };
</script>

<style>
</style>